<template>
    <MetaHeader />
    <div :class="themeMode === 'dark' ? 'dark-mode' : 'light-mode'">
        <router-view />
    </div>
    <Toastr
        ref="toastrRef"
        :text="toastrMsg"
        :type="toastrType"
        :position="toastrPosition"
    ></Toastr>
    <ToastrIconWithBg></ToastrIconWithBg>
    <ToastrFav
        :text="toastrMsg"
        :type="toastrType"
        :position="toastrPosition"
    ></ToastrFav>
    <FavLoginTips ref="favLoginTipsRef"></FavLoginTips>
    <NotificationMatchCard v-if="!isMobile" />
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import ResizeMixin from "@/js/mixin/handleResizeAndRouting.js";
import Toastr from "@/components/toastr/Toastr.vue";
import ToastrIconWithBg from "@/components/toastr/ToastrIconWithBg.vue";
import ToastrFav from "@/components/favourite/Toastr.vue";
import FavLoginTips from "@/components/favourite/TipsLogin.vue";
import NotificationMatchCard from "@/views/notifications/components/MatchCard.vue";
import config from "@/js/config.js";
import { initializeApp, getApps } from "firebase/app";
import {
    getDatabase,
    ref,
    query,
    orderByKey,
    equalTo,
    onValue,
} from "firebase/database";
import { getAuth, signInAnonymously } from "firebase/auth";

const USER = config.localStorageUser;
const USER_LANG = config.localStorageUserLang;
const USER_COUNTRY_CODE = config.localStorageUserCountryCode;

export default {
    components: {
        Toastr,
        ToastrIconWithBg,
        ToastrFav,
        FavLoginTips,
        NotificationMatchCard,
    },
    created() {},
    mounted() {
        this.commonVerifyLogin();
        this.initTheme();
        this.getScrollTop();
        this.initWindowSize();

        const script = document.createElement("script");
        script.setAttribute("src", "https://asset.asiasport.com/testapm.js");
        script.async = true;
        document.head.appendChild(script);
    },
    computed: {
        ...mapState(["themeMode"]),
        ...mapGetters([
            "userLangConfig",
            "currentCountryObj",
            // "userSelectedLangConfigObj",
            "isLogin",
            // "userCountryCode",
            "currentLanguageObj",
            "userInfo",
            "isMobile",
            "isMobileRealTime",
        ]),
    },
    data() {
        return {
            isShowHeader: true,
            toastrMsg: "",
            isHomePage: null,
            init: false,
        };
    },
    watch: {
        isLogin: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    this.REMOVE_USER_LANG_CONFIG();
                    if (location.hostname !== "localhost.testsports168.com") {
                        this.$nextTick(() => {
                            this.iniFirebase();
                        });
                    }
                }
                this.handleMultiCountyLink();
            },
        },
    },
    methods: {
        ...mapMutations([
            "REMOVE_USER_LANG_CONFIG",
            "SET_USER_COUNTRY_CODE",
            "SET_SCROLL_TOP",
            "SET_THEME_MODE",
            "SET_THEME_MODE_INDEX",
            "DEVICE_CHANGE_SIZE_EVENT_REAL_TIME",
        ]),
        ...mapActions([
            "commonVerifyLogin",
            "toggleNewNotification",
            "getCountryCodeByIp",
            "buildCountryBasedLangConfigUi",
            "currentCountryChangeEvent",
        ]),
        initTheme() {
            let theme = localStorage.getItem("themeMode");
            if (!theme) {
                let defaultTheme = "light";
                localStorage.setItem("themeMode", defaultTheme);
                this.SET_THEME_MODE(defaultTheme);
                if (!this.isMobile) {
                    this.SET_THEME_MODE_INDEX("lightWeb");
                } else {
                    this.SET_THEME_MODE_INDEX("lightWebapp");
                }
                document.body.style.background = "var(--gray-100)";
            } else {
                this.SET_THEME_MODE(theme);
                if (theme === "dark") {
                    document.body.style.background = "var(--gray-900)";
                } else {
                    document.body.style.background = "var(--gray-100)";
                }

                if (!this.isMobile) {
                    if (theme === "light") {
                        this.SET_THEME_MODE_INDEX("lightWeb");
                    } else {
                        this.SET_THEME_MODE_INDEX("darkWeb");
                    }
                } else {
                    if (theme === "light") {
                        this.SET_THEME_MODE_INDEX("lightWebapp");
                    } else {
                        this.SET_THEME_MODE_INDEX("darkWebapp");
                    }
                }
            }
        },
        iniFirebase() {
            var firebaseConfig = {
                apiKey: config.RECAPTCHA_API_KEY,
                authDomain: config.RECAPTCHA_AUTH_DOMAIN,
                projectId: config.RECAPTCHA_PROJECT_ID,
                storageBucket: config.RECAPTCHA_STORAGE_BUCKET,
                messagingSenderId: config.RECAPTCHA_MESSAGING_SENDER_ID,
                appId: config.RECAPTCHA_APP_ID,
                databaseURL: config.FIREBASE_DATABASE_URL,
            };

            getApps().length === 0 ? initializeApp(firebaseConfig) : getApps();
            const db = getDatabase();
            const reference = query(
                ref(db, "notification"),
                orderByKey(),
                equalTo(this.userInfo.username)
            );
            signInAnonymously(getAuth()).then(() => {
                onValue(reference, (snapshot) => {
                    if (this.init && snapshot.val()) {
                        this.toggleNewNotification(
                            JSON.parse(Object.values(snapshot.val()))
                        );
                    }
                    if (this.isLogin) {
                        this.init = true;
                    }
                });
            });
        },

        verifyUserLandOnPreferredLang() {
            let preferredLangObj = this.userLangConfig.filter(
                (obj) => obj.selected
            )[0];
            let currentLocale = this.$route.params.locale;

            if (
                this.$route.name === "event" &&
                this.$route.params.locale !== preferredLangObj.displayLocale
            ) {
                window.location.replace(
                    window.location.origin +
                        `/${preferredLangObj.displayLocale}/event`
                );
            } else if (
                this.$route.meta.category !== "eventDetail" &&
                preferredLangObj.displayLocale !== currentLocale
            ) {
                //window.location.replace(window.location.origin + `/${preferredLangObj.displayLocale}`);
            }
        },

        async handleMultiCountyLink() {
            const user = localStorage.getItem("user");

            if (user === null && !this.userCountryCode) {
                let result = await this.getCountryCodeByIp();
                let countryCode = result.result.countryCode;

                if (result.message === "Success") {
                    this.currentCountryChangeEvent(countryCode);

                    // i.e.: ip=th, path=/en, no update contest list
                    let route = this.$route;

                    if (route.name !== "event") {
                        let params = {
                            timeType: 2,
                            language: this.currentLanguageObj.locale,
                            lang: this.currentLanguageObj.apiParam,
                        };

                        const result = await this.getContentList(params);

                        let returnResult = result.result;

                        this.navigationMenuEvent(returnResult);
                    }
                }

                let fullPath = window.location.pathname.split("/");
                if (this.$route.query) {
                    if (
                        this.$route.query.asInit === "init" &&
                        this.currentCountryObj
                    ) {
                        fullPath[1] = this.currentCountryObj.supportedLocale[0];
                        this.$router.replace(fullPath.join("/"));
                    }
                }
                if (this.$route.redirectedFrom) {
                    if (this.$route.redirectedFrom.path === "/") {
                        if (this.currentCountryObj) {
                            if (
                                this.currentCountryObj.supportedLocale.includes(
                                    countryCode.toLowerCase()
                                )
                            ) {
                                this.$router.replace(
                                    `/${this.currentCountryObj.supportedLocale[0]}/football/matches`
                                );
                            }
                        }
                    }
                }
                if (this.currentCountryObj) {
                    if (
                        !this.currentCountryObj.supportedLocale.includes(
                            this.currentLocale
                        )
                    ) {
                        fullPath[1] = this.currentCountryObj.supportedLocale[0];
                        this.$router.replace(
                            fullPath.join("/") + window.location.search
                        );
                    }
                } else {
                    fullPath[1] = config.defaultLocale;
                    this.$router.replace(
                        fullPath.join("/") + window.location.search
                    );
                }
            } else {
                // let fullPath = window.location.pathname.split("/");
                // if (this.$route.query) {
                //   if (this.$route.query.asInit === "init" && this.currentCountryObj) {
                //     fullPath[1] = this.currentLanguageObj.displayLocale;
                //     this.$router.replace(fullPath.join("/"));
                //     // window.location.href = window.location.origin + fullPath.join("/");
                //   }
                // }
                // if (this.$route.name === "signin" && !this.$route.query) {
                //   this.$router.replace(`/${this.currentLocale}/matches`)
                // } else if (this.$route.name === "signin" && this.$route.query) {
                //   let path = this.$route.query.callBackUrl.split("/");
                //   path[1] = this.currentLanguageObj.displayLocale;
                //   this.$router.replace(path.join("/"));
                // }
                // if (this.currentCountryObj) {
                //   if (!this.currentCountryObj.supportedLocale.includes(this.currentLocale)) {
                //       fullPath[1] = this.currentCountryObj.supportedLocale[0];
                //       this.$router.replace(fullPath.join("/") + window.location.search);
                //     }
                // } else {
                //     fullPath[1] = config.defaultLocale;
                //     this.$router.replace(fullPath.join("/") + window.location.search);
                // }
            }
        },
        // AS-1432 - filter language object list based on user preferred country / visitor country
        async langObjListBasedOnCountry() {
            // if (localStorage.getItem(USER_LANG) === null) { // first time loading (non-logged in) / redirect from just logged out
            let locatedCountryCode = null;
            if (localStorage.getItem(USER) === null) {
                // && localStorage.getItem(USER_COUNTRY_CODE) === null
                // get user's current located country code
                let result = await this.getCountryCodeByIp();
                if (result.message === "Success") {
                    locatedCountryCode = result.result.countryCode; //result.result.countryCode 'KH'
                    // this.SET_USER_COUNTRY_CODE(locatedCountryCode);
                }
            }

            this.$nextTick(() => {
                if (
                    localStorage.getItem(USER) !== null &&
                    localStorage.getItem(USER_LANG) === null
                ) {
                    let params = {
                        countryCode: this.userInfo.preferredCountry,
                        action: "No_Action",
                    };
                    this.buildCountryBasedLangConfigUi(params);
                }

                if (localStorage.getItem(USER) === null) {
                    // && localStorage.getItem(USER_LANG) === null
                    let params = {
                        countryCode: locatedCountryCode,
                        action: "No_Action",
                    };
                    this.buildCountryBasedLangConfigUi(params);
                }

                this.verifyUserLandOnPreferredLang();
            });
        },
        getScrollTop() {
            let that = this;
            window.addEventListener("scroll", function (event) {
                that.SET_SCROLL_TOP(event.target.scrollingElement.scrollTop);
            });
        },
        initWindowSize(firstTime) {
            // screen width > for web and webapp changing
            // inner width > for web size adjust checking, screen width not checking this
            this.DEVICE_CHANGE_SIZE_EVENT_REAL_TIME(
                window.innerWidth <= 768 ? true : false
            );
            this.handleWindowSize();
            this.handleHeaderSize()

            window.addEventListener("resize", () => {
                this.DEVICE_CHANGE_SIZE_EVENT_REAL_TIME(
                    window.innerWidth <= 768 ? true : false
                );
                this.handleWindowSize();
                this.handleHeaderSize()
            });
            window.screen.orientation.addEventListener("change", () => {
                this.DEVICE_CHANGE_SIZE_EVENT_REAL_TIME(
                    window.innerWidth <= 768 ? true : false
                );
                this.handleWindowSize();
            });
        },
        handleHeaderSize() {
            let maxWidth = 0;
            [...document.querySelectorAll('*')].filter(el => {
                return el.scrollWidth > document.documentElement.clientWidth;
            }).forEach(el => {
                    if(el.scrollWidth >= 768) {
                        if(el.scrollWidth > maxWidth) {
                            maxWidth = el.scrollWidth 
                        }
                    }
                    
            });
            // 设置 .full-screen-width 的宽度
            document.querySelectorAll('.full-screen-width').forEach(el => {
                if(maxWidth === 0) {
                    el.style.width = '100%'
                } else {
                    el.style.width = `${maxWidth}px`;
                }
            });
        },
        handleWindowSize() {
            let theme = localStorage.getItem("themeMode");
            if (!this.isMobileRealTime) {
                if (theme === "light") {
                    this.SET_THEME_MODE_INDEX("lightWeb");
                } else {
                    this.SET_THEME_MODE_INDEX("darkWeb");
                }
            } else {
                if (theme === "light") {
                    this.SET_THEME_MODE_INDEX("lightWebapp");
                } else {
                    this.SET_THEME_MODE_INDEX("darkWebapp");
                }
            }
        },
    },
    mixins: [ResizeMixin],
};
</script>

<style>
@import url("https://cdnjs.cloudflare.com/ajax/libs/Swiper/6.5.8/swiper-bundle.css");
@import url("https://cdn.jsdelivr.net/npm/mc-datepicker/dist/mc-calendar.min.css");

/* @import '../src/js/swipper.js'; */

#app {
    /* font-family: 'Open Sans', Arial, sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--color-text-default-default);
    height: 100%;
    min-width: 1200px;
}
@media(max-width: 768px) {
#app {
    min-width: unset;
}
}
</style>
